import { ModelBase } from 'store/model-base';

export class CmsLevelMoveStart extends ModelBase {
    public static storeName: string = 'cmsLevelMoveStart';

    public pageTitle: string;
    public planSevenPageTitle: string;
    public header: string;
    public planSixHeader: string;
    public icon5G: CmsMediaImage;
    public planSixIcon: CmsMediaImage;
    public unlimitedIcon: CmsMediaImage;
    public byTheGigIcon: CmsMediaImage;
    public protectDeviceIcon: CmsMediaImage;
    public dollarIcon: CmsMediaImage;
    public planGroupInfo: CmsLevelMovePlanFeaturesGroup[];
    public planSevenCBMGroupInfo: CmsLevelMovePlanSixFeaturesGroup[];
    public planEightGroupInfo: CmsLevelMovePlanSixFeaturesGroup[];
    public planSevenPlanChangeTable: CmsPlanSevenPlanChangeTable;
    public planEightPlanChangeTable: CmsPlanEightPlanChangeTable;
    public timeInfo: CmsTimeInfoData;
    public cancelBtn: string;
    public upgradeBtn: string;
    public upgradeAndSwitchBtn: string;
    public expandIcon: CmsMediaImage;
}
